import { createSlice } from "@reduxjs/toolkit";
/**
 * Modal State Shape:
 * {
 *   isOpen: boolean,
 *   type: string | null,   // e.g. "ORDER_DETAILS", "CONFIRM_DELETE"
 *   props: object          // payload for the modal (orderId, callbacks, etc.)
 * }
 */

const initialState = {
    isOpen: false,
    type: null,
    props: {},
};

const modalSlice = createSlice({
    name: "modal",
    initialState,
    reducers: {
        openModal: (state, action) => {
            const { type, props = {} } = action.payload || {};
            state.isOpen = true;
            state.type = type ?? null;
            state.props = props;
        },

        closeModal: (state) => {
            state.isOpen = false;
            state.type = null;
            state.props = {};
        },

        // Useful if you want to update a prop while the modal is open (e.g. step, loading flag)
        patchModalProps: (state, action) => {
            const patch = action.payload || {};
            state.props = { ...state.props, ...patch };
        },

        // Optional: force reset without worrying about open/close
        resetModal: () => initialState,
    },
});

export const { openModal, closeModal, patchModalProps, resetModal } =
    modalSlice.actions;

export default modalSlice.reducer;

// Selectors
export const selectModal = (state) => state.modal;
export const selectModalOpen = (state) => state.modal.isOpen;
export const selectModalType = (state) => state.modal.type;
export const selectModalProps = (state) => state.modal.props;
